import { DateTime } from "luxon";
import moment from "moment";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { createEntity } from "../../scripts/helperScripts";
import FloatingInput from "../common/FloatingInput";
import { SOARResources } from "../services/soar";

function ClientSearch({ state, show, setShow, setClient, hideNewClient }) {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [clientData, setClientData] = useState({});
  const [newClient, setNewClient] = useState(false);
  const [saveInProgress, setSaveInProgress] = useState(false);
  const [selectedClient, setSelectedClient] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (state) {
      const getClients = async () => {
        setLoading(true);
        const body = {
          command: "query",
          environment:
            process.env.REACT_APP_ENVIRONMENT === "Production"
              ? "SOARQueryLive"
              : "SOARQueryBase",
          resource: "client",
          keyword: "companyinterm",
          searchTerms: {
            company: state,
          },
        };

        const resp = await SOARResources(body);
        setLoading(false);

        if (resp.code === "success") {
          setClients(resp.data);
        } else {
          console.log("Error Response", resp);
          toast.error(`Error Loading clients. ${resp.message}`);
        }
      };

      getClients();
    }
  }, [state]);

  const handlePhoneChange = (e) => {
    if (e.currentTarget.value !== "") {
      if (
        clientData.phone !== "" &&
        e.currentTarget.value.length < clientData.phone?.length &&
        (clientData.phone[clientData.phone?.length - 1] === "-" ||
          clientData.phone[clientData.phone?.length - 1] === ")" ||
          clientData.phone[clientData.phone?.length - 1] === "(")
      ) {
        e.currentTarget.value = e.currentTarget.value.slice(0, -1);
      }

      const phoneNumber = formatPhoneNumber(e.currentTarget.value);
      e.currentTarget.value = phoneNumber;
    }

    setClientData((cd) => ({ ...cd, phone: e.target.value }));
  };

  const formatPhoneNumber = (phoneNumberString) => {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    let phoneNumber = "";
    if (cleaned[0]) phoneNumber += `(${cleaned[0]}`;
    if (cleaned[1]) phoneNumber += cleaned[1];
    if (cleaned[2]) phoneNumber += `${cleaned[2]})`;
    if (cleaned[3]) phoneNumber += ` ${cleaned[3]}`;
    if (cleaned[4]) phoneNumber += cleaned[4];
    if (cleaned[5]) phoneNumber += `${cleaned[5]}-`;
    if (cleaned[6]) phoneNumber += cleaned[6];
    if (cleaned[7]) phoneNumber += cleaned[7];
    if (cleaned[8]) phoneNumber += cleaned[8];
    if (cleaned[9]) phoneNumber += cleaned[9];
    return phoneNumber;
  };

  const countMatchingLetters = (str1, str2) => {
    if (!str1 || !str2) return 0;
    const s1 = str1.toUpperCase();
    const s2 = str2.toUpperCase();
    if (!s2.includes(s1)) return 0;
    let count = 0;
    for (let i = 0; i < s1.length; i++) {
      if (s2.includes(s1[i])) {
        count++;
      }
    }
    return count;
  };

  const matchFields = () => {
    const filteredClients = clients.filter(
      (c) =>
        (clientData?.firstName !== "" &&
          c.name?.first
            ?.toUpperCase()
            .includes(clientData?.firstName?.toUpperCase())) ||
        (clientData?.lastName !== "" &&
          c.name?.last
            ?.toUpperCase()
            .includes(clientData?.lastName?.toUpperCase())) ||
        (clientData?.email !== "" &&
          c.email1?.toUpperCase().includes(clientData.email?.toUpperCase())) ||
        (clientData?.phone !== "" &&
          c.phone2?.toUpperCase().includes(clientData.phone?.toUpperCase()))
    );

    const sortedClients = filteredClients.sort((a, b) => {
      const firstNameMatchA = countMatchingLetters(
        clientData?.firstName,
        a.name?.first
      );
      const lastNameMatchA = countMatchingLetters(
        clientData?.lastName,
        a.name?.last
      );
      const emailMatchA = countMatchingLetters(clientData?.email, a.email1);
      const phoneMatchA = countMatchingLetters(clientData?.phone, a.phone2);
      const firstNameMatchB = countMatchingLetters(
        clientData?.firstName,
        b.name?.first
      );
      const lastNameMatchB = countMatchingLetters(
        clientData?.lastName,
        b.name?.last
      );
      const emailMatchB = countMatchingLetters(clientData?.email, b.email1);
      const phoneMatchB = countMatchingLetters(clientData?.phone, b.phone2);

      const totalMatchA =
        firstNameMatchA + lastNameMatchA + emailMatchA + phoneMatchA;
      const totalMatchB =
        firstNameMatchB + lastNameMatchB + emailMatchB + phoneMatchB;

      return totalMatchB - totalMatchA;
    });

    return sortedClients.length > 0 ? (
      <div className="table-responsive">
        <div className="row fw-bold mb-2 d-none d-md-flex">
          <div className="col-md-2">First</div>
          <div className="col-md-2">Last</div>
          <div className="col-md-2">DOB</div>
          <div className="col-md-1">MPI</div>
          <div className="col-md-3">Phone/Email</div>
          <div className="col-md-2">Actions</div>
        </div>
        {sortedClients.map((c, index) => (
          <div key={`pc-${index}-${c.id}`} className="mb-3">
            <div
              className={`row rounded border border-dark card-safy p-2 ${
                c.name.full.toUpperCase() ===
                  `${clientData.firstName} ${clientData.lastName}`.toUpperCase() ||
                c.name.full.toUpperCase() ===
                  `${clientData.lastName}, ${clientData.firstName}`.toUpperCase()
                  ? "bg-success text-white"
                  : "bg-light"
              }`}
              title={c.programs?.map((p) => `${p.name}`).join(", ")}
            >
              <div className="col-6 col-md-2 mb-1">
                <span className="d-md-none fw-bold">First: </span>
                {clientData.firstName !== "" &&
                c.name.first
                  ?.toUpperCase()
                  .includes(clientData.firstName?.toUpperCase()) ? (
                  <>
                    {c.name.first
                      .toLowerCase()
                      .split(clientData.firstName?.toLowerCase())[0]
                      .replace(/\b\w/g, (match) => match.toUpperCase())}
                    <mark>{clientData.firstName}</mark>
                    {
                      c.name.first
                        .toLowerCase()
                        .split(clientData.firstName?.toLowerCase())[1]
                    }
                  </>
                ) : (
                  c.name.first
                )}
              </div>
              <div className="col-6 col-md-2 mb-1">
                <span className="d-md-none fw-bold">Last: </span>
                {clientData.lastName !== "" &&
                c.name.last
                  ?.toUpperCase()
                  .includes(clientData.lastName?.toUpperCase()) ? (
                  <>
                    {c.name.last
                      .toLowerCase()
                      .split(clientData.lastName?.toLowerCase())[0]
                      .replace(/\b\w/g, (match) => match.toUpperCase())}
                    <mark>{clientData.lastName}</mark>
                    {
                      c.name.last
                        .toLowerCase()
                        .split(clientData.lastName?.toLowerCase())[1]
                    }
                  </>
                ) : (
                  c.name.last
                )}
              </div>
              <div className="col-6 col-md-2 mb-1">
                <span className="d-md-none fw-bold">DOB: </span>
                <div>{moment(c.dob).format("MM/DD/YYYY")}</div>
              </div>
              <div className="col-6 col-md-1 mb-1">
                <span className="d-md-none fw-bold">MPI: </span>
                <div>{c.mpi}</div>
              </div>
              <div
                className={`col-12 col-md-3 mb-1 ${
                  (clientData.email !== "" &&
                    c.email1?.toUpperCase() ===
                      clientData.email?.toUpperCase()) ||
                  (clientData.phone !== "" &&
                    c.phone2?.toUpperCase() === clientData.phone?.toUpperCase())
                    ? "rounded border border-white bg-success text-white px-1"
                    : ""
                }`}
              >
                <span className="d-md-none fw-bold">Contact: </span>
                <div>{c.email1}</div>
                <div>{c.phone2}</div>
              </div>
              <div className="col-12 col-md-2 d-flex justify-content-between align-items-center">
                {c.programs && (
                  <button
                    className="btn btn-sm btn-info text-white me-2"
                    onClick={() =>
                      setSelectedClient(c.id === selectedClient ? "" : c.id)
                    }
                  >
                    <i className="fas fa-info-circle me-1"></i>
                    {c.id === selectedClient ? "Hide" : "Info"}
                  </button>
                )}
                <button
                  className="btn btn-sm btn-warning"
                  onClick={() => {
                    const obj = {
                      contactid: c.id,
                      fullname: c.name.full,
                      firstname: c.name.first,
                      lastname: c.name.last,
                      programs: c.programs,
                      dob: c.dob,
                      mpi: c.mpi,
                    };

                    setClient(obj);
                    setShow(false);
                  }}
                >
                  Select
                </button>
              </div>
            </div>
            {c.id === selectedClient && c.programs && (
              <div className="bg-light p-2 border border-top-0 rounded-bottom">
                <div className="fw-bold mb-1">Programs:</div>
                {c.programs.map((p, index) => (
                  <div className="row my-1" key={`progs${index}`}>
                    <div className="col-12 col-md-5">
                      {p.name
                        .toUpperCase()
                        .replace(`${state.toUpperCase()} - `, "")}
                    </div>
                    <div className="col-6 col-md-3">
                      {`Admit: ${moment(p.admission).format("MM/DD/YYYY")}`}
                    </div>
                    <div className="col-6 col-md-3">
                      {`Discharge: ${moment(p.discharge).format("MM/DD/YYYY")}`}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    ) : null;
  };

  const getCompany = () => {
    switch (state) {
      case "SAFY of Alabama":
        return "{6C0C4523-44BF-E211-90BC-005056822045}";
      case "SAFY of Colorado":
        return "{8856675B-ABE2-E411-B77B-005056822045}";
      case "SAFY of Indiana":
        return "{8F00A03B-14A0-E511-8ACA-005056822045}";
      case "SAFY of Kentucky":
        return "{97D87A49-14A0-E511-8ACA-005056822045}";
      case "SAFY of Nevada":
        return "{137D0EF9-13A0-E511-8ACA-005056822045}";
      case "SAFY of Ohio":
        return "{1C16C69A-4544-E611-8588-005056822045}";
      case "SAFY of South Carolina":
        return "{B699545E-2541-E511-8ACA-005056822045}";
      default:
        return "";
    }
  };

  const validate = () => {
    let valid = true;

    if (clientData.phone) {
      var phoneRegex = /(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}/;
      const match = phoneRegex.exec(clientData.phone);

      if (!match) {
        setErrors((errs) => {
          const obj = { ...errs };
          obj.phone = `Please enter a valid "Phone" number`;
          return obj;
        });

        valid = false;
      } else {
        setErrors((errs) => {
          const obj = { ...errs };
          delete obj.phone;
          return obj;
        });
      }
    }

    return valid;
  };

  const createNewClient = () => {
    if (!validate()) {
      return;
    }

    const clientCompanyObj = {
      ccx_company: {
        type: "entity",
        value: {
          entityName: "ccx_agency",
          entityId: getCompany(),
        },
      },
      ccx_admitdate: {
        type: "datetime",
        value: new Date(DateTime.now().toISODate()),
      },
    };

    const contactObj = {
      ccx_contacttype: {
        type: "optionset",
        value: 803080001,
      },
      firstname: {
        type: "string",
        value: clientData.firstName,
      },
      lastname: {
        type: "string",
        value: clientData.lastName,
      },
    };

    if (clientData.phone && clientData.phone !== "")
      contactObj.mobilephone = { type: "string", value: clientData.phone };
    if (clientData.middleName && clientData.middleName !== "")
      contactObj.middlename = { type: "string", value: clientData.middleName };
    if (clientData.suffix && clientData.suffix !== "")
      contactObj.ccx_namesuffix = {
        type: "optionset",
        value: parseInt(clientData.suffix),
      };
    if (clientData.preferredFirst && clientData.preferredFirst !== "")
      contactObj.ccx_alias1 = {
        type: "string",
        value: clientData.preferredFirst,
      };
    if (clientData.preferredLast && clientData.preferredLast !== "")
      contactObj.ccx_alias2 = {
        type: "string",
        value: clientData.preferredLast,
      };
    if (clientData.dob && clientData.dob !== "")
      contactObj.birthdate = {
        type: "datetime",
        value: new Date(clientData.dob),
      };
    if (clientData.ssn && clientData.ssn !== "")
      contactObj.ccx_ssn = { type: "string", value: clientData.ssn };
    if (clientData.sex && clientData.sex !== "")
      contactObj.gendercode = {
        type: "optionset",
        value: parseInt(clientData.sex),
      };
    if (clientData.gender && clientData.gender !== "")
      contactObj.sor_preferredgender = {
        type: "optionset",
        value: parseInt(clientData.gender),
      };
    if (clientData.sexualOrientation && clientData.sexualOrientation !== "")
      contactObj.sor_sexualorientation = {
        type: "optionset",
        value: parseInt(clientData.sexualOrientation),
      };

    const toastId = toast.loading(
      `Contact ${clientData.lastName}, ${clientData.firstName} is being created...`,
      { type: toast.TYPE.INFO }
    );
    setSaveInProgress(true);
    createEntity(
      "contact",
      JSON.stringify(contactObj),
      JSON.parse(localStorage.getItem("safyInfo")),
      state.split(" of ")[1]
    )
      .then((contactResponse) => {
        // console.log(
        //   "Contact Response",
        //   contactResponse,
        //   contactResponse.resultset.result.contactid
        // );
        const contactResult = contactResponse.resultset.result;
        setClient(contactResult);

        clientCompanyObj.ccx_client = {
          type: "entity",
          value: {
            entityName: "contact",
            entityId: contactResult.contactid,
          },
        };

        // toast.update(toastId, {
        //   render:
        //     "Contact has been created. Client Company is being created...",
        // });

        createEntity(
          "ccx_clientagency",
          JSON.stringify(clientCompanyObj),
          JSON.parse(localStorage.getItem("safyInfo")),
          state.split(" of ")[1]
        )
          .then((clientCompanyResponse) => {
            // console.log("Client Company Response", clientCompanyResponse);
            toast.update(toastId, {
              render:
                "Client Company has been created. Admission records are being created...",
              type: toast.TYPE.SUCCESS,
              isLoading: false,
              closeOnClick: true,
              autoClose: 2000,
            });
            setSaveInProgress(false);
            setShow(false);
          })
          .catch(() => {
            toast.update(toastId, {
              render: "An error occurred while creating the Client Company.",
              type: toast.TYPE.ERROR,
              isLoading: false,
              closeOnClick: true,
              autoClose: 5000,
            });
            setSaveInProgress(false);
            setShow(false);
          });
      })
      .catch(() => {
        toast.update(toastId, {
          render: "An error occurred while creating the Contact.",
          type: toast.TYPE.ERROR,
          autoClose: 5000,
          isLoading: false,
          closeOnClick: true,
        });
        setSaveInProgress(false);
      });
  };

  const clearFields = () => {
    console.log("Clearing Fields");
    setClientData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      preferredFirst: "",
      middleName: "",
      suffix: "",
      preferredLast: "",
      dob: "",
      ssn: "",
      gender: "",
      sex: "",
      sexualOrientation: "",
    });
  };

  return (
    <div className="container-fluid px-0">
      <div className="row g-2">
        <div className="col-12 col-md-6 mb-2">
          <FloatingInput
            name="firstName"
            label="First Name"
            value={clientData.firstName || ""}
            onChange={(e) =>
              setClientData({ ...clientData, firstName: e.target.value })
            }
          />
        </div>
        <div className="col-12 col-md-6 mb-2">
          <FloatingInput
            name="lastName"
            label="Last Name"
            value={clientData.lastName || ""}
            onChange={(e) =>
              setClientData({ ...clientData, lastName: e.target.value })
            }
          />
        </div>
        <div className="col-12 col-md-6 mb-2">
          <FloatingInput
            name="email"
            label="Email"
            value={clientData.email || ""}
            onChange={(e) =>
              setClientData({ ...clientData, email: e.target.value })
            }
          />
        </div>
        <div className="col-12 col-md-6 mb-2">
          <FloatingInput
            name="phone"
            label="Phone"
            value={clientData.phone || ""}
            onChange={handlePhoneChange}
          />
          {errors.phone && (
            <div className="text-danger small mt-1">{errors.phone}</div>
          )}
        </div>
        <div className="col-12 d-flex justify-content-between mb-3">
          {!hideNewClient && (
            <button
              className="btn btn-primary"
              onClick={() => setNewClient(!newClient)}
            >
              {newClient ? "Back to Client Search" : "Setup as New Client"}
            </button>
          )}
          <button className="btn btn-danger ms-2" onClick={clearFields}>
            Clear Fields
          </button>
        </div>
      </div>

      {!loading ? (
        <div className="row">
          <div className="col">
            {newClient === false ? (
              matchFields()
            ) : (
              <div className="card p-3 bg-light">
                <h5 className="card-title mb-3">New Client Setup</h5>
                <div className="row g-2">
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      label="First Name"
                      name="firstName"
                      value={clientData.firstName || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          firstName: e.target.value,
                        })
                      }
                      error={errors.firstName}
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      label="Middle Name"
                      name="middleName"
                      value={clientData.middleName || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          middleName: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      label="Last Name"
                      name="lastName"
                      value={clientData.lastName || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          lastName: e.target.value,
                        })
                      }
                      error={errors.lastName}
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      label="Preferred First Name"
                      name="preferredFirst"
                      value={clientData.preferredFirst || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          preferredFirst: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      label="Preferred Last Name"
                      name="preferredLast"
                      value={clientData.preferredLast || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          preferredLast: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      type="date"
                      label="Birthdate"
                      name="dob"
                      value={clientData.dob || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          dob: e.target.value,
                        })
                      }
                      error={errors.dob}
                    />
                  </div>
                  <div className="col-12 col-md-6 mb-2">
                    <FloatingInput
                      label="SSN"
                      name="ssn"
                      value={clientData.ssn || ""}
                      onChange={(e) =>
                        setClientData({
                          ...clientData,
                          ssn: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={createNewClient}
                    disabled={saveInProgress || Object.keys(errors).length > 0}
                  >
                    Create Client
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      ) : (
        <div className="h5 text-primary">Loading clients</div>
      )}
    </div>
  );
}

export default ClientSearch;
